import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { GET_CHATS_FOR_THREAD, ADD_CHAT_TO_THREAD, REMOVE_MESSAGE } from '../../Actions/Wazzup'
import { SET_PROFILE_OPEN } from '../../Actions/Sidebar'
import { GiftedChat } from 'react-gifted-chat';
import Bubble from '../../Components/Chat/Bubble'
import Composer from '../../Components/Chat/Composer'
import Lightbox from '../../Components/Lightbox/Index'
import Sidebar from '../../Components/Sidebar/Index.js'
import { MERCURE_URL } from '../../config'
import { BubbleIcon, CloseIcon, RemoveIcon } from '../../Svg/Index.js'
import Loader from '../../Components/Loader/Index.js'
import Linkify from 'react-linkify';


const componentDecorator = (href, text, key) => (
    <a class="linkify-link" href={href} key={key} target="_blank" style={{color: 'inherit'}}>
        {text}
    </a>
);

class WazzupChat extends Component {
    state = {
        messages: [],
        popupOpen: false,
        popupSource: null,
        chatLoading: false,
        dialogActive: false,
        removingMessage: null,
	}

    UNSAFE_componentWillMount() {
        const { user } = this.props;
        const { uuid } = this.props.match.params
        if(!user.token) {
            this.props.history.push('/')
        }

        this.setState({
            chatLoading: true
        })
        
        this.props.actions.GET_CHATS_FOR_THREAD(uuid).then(initialMessages => {
			this.setState({
				messages: initialMessages.map(r => {
					r.user.avatar = r.user.avatar.user_avatar
					if(r.image) {
						r.image = r.image.message_medium
					}
					return r
                }),
                chatLoading: false
            }, () => {
            });
		})
    }

    componentDidMount() {
        const { uuid } = this.props.match.params
		const LISTEN_URL = `${MERCURE_URL}?topic=https://jongenout.nl/threads/${encodeURIComponent(uuid)}`
		this.eventSource = new EventSource(LISTEN_URL);
		this.eventSource.addEventListener('message', this.handleMercure)
    }

    componentWillUnmount() {
        if(this.eventSource) {
		    this.eventSource.removeEventListener('message', this.handleMercure)
            this.eventSource.close();
        }
	}

    handleMercure = (event) => {
        let message = JSON.parse(event.data)
		if(!message.type) {
			message.user.avatar = message.user.avatar.user_avatar
			if(message.image) {
				message.image = message.image.message_medium
			}
			this.setState({
				messages: [message, ...this.state.messages]
			})
		} else {
			this.setState({
				messages: this.state.messages.filter((item)=> {
					return item._id !== message.id
				})
			})
		}
	}

    postToServer = (props) => {
        const { uuid } = this.props.match.params
        this.props.actions.ADD_CHAT_TO_THREAD(this.props.composer, uuid).then(()=> {

            setTimeout(()=> {
                document.querySelectorAll('.o-web-container')[0].scrollTo(0, document.querySelectorAll('.o-web-container')[0].scrollHeight + 200)
            }, 10)
        })
    }
    
    handlePopupSource = (source) => {
        this.setState({
            popupSource: source,
            popupOpen: true
        });
    }

    handlePopupClose = () => {
        this.setState({
            popupSource: null,
            popupOpen: false
        });
    }

    handlePopupOpen = (src) => {
        this.setState({
            popupSource: src,
            popupOpen: true
        });
    }

    handleBack = () => {
        this.props.history.goBack()
    }

    openProfile = (props)=> {
        if(props.roles.includes("ROLE_ANONYMOUS")) return;
        this.props.actions.SET_PROFILE_OPEN(props._id)
        document.body.classList.add('sidebar-open');
    }

    handleRemoveDialog = (id) => {
        this.setState({
            dialogActive: true,
            removingMessage: id
        })        
    }

    handleMessageRemove = () => {
        this.setState({
            dialogActive: false
        })
        this.props.actions.REMOVE_MESSAGE(this.state.removingMessage).then((res)=> {
            if(res.was_first_post) {
                this.props.history.goBack()
            }
        })
    }

    render() {
        const { user } = this.props;
        const { messages, popupOpen, popupSource, chatLoading, dialogActive } = this.state;
        
        const openingPost = messages[messages.length - 1];

        const isGroup = this.props.location.isGroup;

        return (
            <>
                <Lightbox active={popupOpen} source={popupSource} handleLightboxClose={this.handlePopupClose} />
                {
                    chatLoading && (
                        <Loader />
                    )
                }
                
                <div className="o-page-wrap">
                    
                    <Sidebar />

                    <div className="o-main-container o-main-container--alt">
                        <div className="c-fixed-back-btn-wrapper">
                            <button to="/wazzup" className="c-bare-btn c-fixed-back-btn c-btn c-btn--with-icon" onClick={this.handleBack}>
                                <CloseIcon />
                            </button>
                        </div>

                        {
                            dialogActive && (
                                <div className="c-dialog">
                                    <div className="c-dialog__inner">
                                        <h2>Wil je dit bericht verwijderen?</h2>
                                        <button className="c-btn c-btn--primary" onClick={this.handleMessageRemove}>Ja, verwijder</button>
                                        <button className="c-btn c-btn--primary" onClick={ () => this.setState({dialogActive: false}) }>Nee, annuleren</button>
                                    </div>
                                </div>
                            )
                        }

            
                        <div className="c-chat">
                            <GiftedChat
                                locale="nl"
                                messages={messages}
                                showUserAvatar
                                onPressAvatar={(props)=> this.openProfile(props)}

                                showAvatarForEveryMessage
                                placeholder={`Typ hier je bericht...`}
                                renderBubble={props => {
                                    return (
                                        <>
                                            {
                                                props.currentMessage._id === openingPost._id && (
                                                    <div className={`c-card c-card--opening-post ${props.currentMessage.user._id === user._id ? 'c-card--opening-post--alt' : ''}`}>
                                                        
                                                        {
                                                            props.currentMessage.user._id === user._id && (
                                                                <span className="c-card__remove" onClick={() => this.handleRemoveDialog(props.currentMessage._id)}><RemoveIcon /></span>
                                                            )
                                                        }
                                                        
                                                        
                                                        <div className="c-card__inner">
                                                            <div className="c-card__author" style={{cursor: 'pointer'}} onClick={()=> this.openProfile(openingPost.user)}>
                                                                <img src={props.currentMessage.user.avatar} alt=""/>
                                                            </div>
                                                            <div className="c-card__content" style={{pointerEvents: 'auto', cursor: 'auto'}}>
                                                                <div className="c-card__label u-small" style={{pointerEvents: 'none'}}>
                                                                    <span className={`${ (openingPost.user.roles.includes("ROLE_COORDINATOR") && isGroup) ? 'coordinator' : '' }`}>{ (openingPost.user.roles.includes("ROLE_COORDINATOR") && isGroup) ? '★ ' : '' }{openingPost.user.display_name} { (openingPost.user.roles.includes("ROLE_COORDINATOR") && isGroup) ? '★' : '' }</span>
                                                                    <span>{openingPost.created_at_for_humans}</span>
                                                                </div>
                                                                {
                                                                    openingPost.image && (
                                                                        <div className="c-card__media" style={{cursor: 'pointer'}} onClick={() => this.handlePopupOpen(openingPost.image)}>
                                                                            <img src={openingPost.image} alt=""/>
                                                                        </div>
                                                                    )
                                                                }
                                                                <div className="c-card__message" style={{pointerEvents: 'none'}}>
                                                                    <Linkify componentDecorator={componentDecorator}>
                                                                        {openingPost.body}
                                                                    </Linkify>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }

                                            {
                                                props.currentMessage._id !== openingPost._id && (
                                                    <div className={`c-bubble ${props.currentMessage.user._id === user._id ? 'c-bubble--alt' : ''}`}>
                                                        <span className={`c-bubble__name ${ (props.currentMessage.user.roles.includes("ROLE_COORDINATOR") && isGroup) ? 'coordinator-alt' : '' }`}>{ (props.currentMessage.user.roles.includes("ROLE_COORDINATOR") && isGroup) ? '★ ' : '' }{props.currentMessage.user.display_name} { (props.currentMessage.user.roles.includes("ROLE_COORDINATOR") && isGroup) ? '★' : '' }</span>
                                                        <span className="c-bubble__remove" onClick={() => this.handleRemoveDialog(props.currentMessage._id)}><RemoveIcon /></span>
                                                        <div className="c-bubble__inner">
                                                            <Bubble {...props} handleLightboxOpen={this.handlePopupSource} />
                                                            <span className="c-bubble__icon">
                                                                <BubbleIcon />
                                                            </span>
                                                        </div>
                                                    </div>
                                                )
                                            }

                                            
                                        </>
                                    )
                                }}
                                renderInputToolbar={() => null}
						        renderComposer={() => null}
                                user={{
                                    _id: user._id,
                                    name: user.display_name,
                                    avatar: user.avatar.user_avatar,
                                }}
                                onSend={this.postToServer}
                            />
                            <Composer handleSend={this.postToServer} />
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
const mapStateToProps = state => {
    return {
        user: state.user.user,
        wazzup: state.wazzup,
		composer: state.composer.composer
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({SET_PROFILE_OPEN,  GET_CHATS_FOR_THREAD, ADD_CHAT_TO_THREAD, REMOVE_MESSAGE}, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WazzupChat)